import React from "react"
import Carousel from "./Carousel"
import styles from "./styles.scss"
import TeamMembers from "./TeamMembers"

class Team extends React.Component {
  render() {
    return (
      <section className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.textContainer}>
            <h2 className={styles.title}>Teamet</h2>
          </div>
          <div className={styles.teamMemberContainer}>
            <Carousel className={styles.carousel} />
            <TeamMembers className={styles.teamMembers} />
          </div>
        </div>
      </section>
    )
  }
}

export default Team



// WEBPACK FOOTER //
// ./src/components/JobDescription/Team/index.jsx